import axios from "../utils/axios-interceptor";

export const uploadRepoCodeApi = async(payload) => {
  try {
    const res = await axios.post("/download_repo", payload);
    let data = await res.data;
    data.repoLink = payload.repoLink;
    return { data }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const uploadCodeApi = async(payload) => {
  try {
    const form = new FormData();
    for (let i = 0; i < payload.source_files.length; i++) {
      form.append("file", payload.source_files[i])
    }
    const res = await axios.post("/upload_repo", form, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
    let data = await res.data;
    data.repoLink = payload.repoLink;
    return { data }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const upgradeApi = async(payload) => {
  try {
    const headers = {
      accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };
      
    const data = new URLSearchParams(payload);
    const res = await axios.post("/upgrade", data, {headers});
    let response = await res.data;
    return { response }
  } catch (error) {
    console.log("Error in API: ", error)
    if(error.data && error.data.details){
      console.log("Error in API: ", error)
      throw new Error(error.data.details)
    }
    throw new Error(error.message)
  }
}

export const fixVulerabilitiesApi = async(payload) => {
  try {
    const res = await axios.post("/fix_vulnerabilities", payload);
    let data = await res.data;
    data.repoLink = payload.repoLink;
    return { data }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const download_file = async(payload) => {
  try {
    // const res = await axios.get(`/download_files?file_path=${payload.downloadUrl}`);
    const res = await axios.get(`/download_files?file_path=${payload.downloadUrl}`);

    // Create a Blob from the response data
    // const blob = new Blob([res.data], { type: "application/zip" });
    const data = await res.data
    // const blob = res.arrayBuffer();
    // console.log("Data: ", blob)
    return {
      file: data.download_url
    }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const createWebSocketConnection = (url, onOpen, onMessage, onError, onClose) => {
  const socket = new WebSocket(url);

  // Function to check the WebSocket connection status
  function checkWebSocketStatus() {
    switch (socket.readyState) {
    case WebSocket.CONNECTING:
      console.log("WebSocket is connecting...");
      break;
    case WebSocket.OPEN:
      onOpen && onOpen()
      break;
    case WebSocket.CLOSING:
      console.log("WebSocket is closing...");
      break;
    case WebSocket.CLOSED:
      console.log("WebSocket is closed.");
      break;
    default:
      console.log("Unknown WebSocket state:", socket.readyState);
    }
  }

  // Check the connection periodically
  setInterval(() => {
    checkWebSocketStatus();
  }, 1000);

  // waitForConnection(socket);
  socket.onopen = () => {
    console.log("Socket connection opened....")
  }

  socket.onmessage = (event) => {
    if (onMessage) onMessage(event.data);
  };

  socket.onerror = (error) => {
    if (onError) console.error("WebSocket Error:", error);
  };

  socket.onclose = () => {
    if (onClose) console.warn("WebSocket connection closed");
  };

  return socket;
};

